<template>
  <div class="row content-movimentation">
    <div
      :class="[
        'col-md-4 pt-0 pb-0',
        report_type == 'analytical' && 'col-md-7',
        report_type == 'general' && 'col-md-7',
      ]"
    >
      <div class="row">
        <div
          :class="[
            'd-flex align-items-center justify-content-center pt-0 pb-0',
            report_type == 'general' && 'col-md-4',
            report_type == 'analytical' && 'col-md-2',
          ]"
        >
          <h6 v-if="report_type == 'general'" class="row m-0">
            <span class="col-md-2 pt-0 pb-0 date-amount"
              >{{ moment(date.dateInit).format("DD") }}/</span
            >
            <span class="col-md-2 pt-0 pb-0 date-amount"
              >{{ moment(date.dateInit).format("MM") }}/</span
            >
            <span class="col-md-2 pt-0 pb-0 date-amount">{{
              moment(date.dateInit).format("YYYY")
            }}</span>
          </h6>
          <h6 class="row m-0">
            <span class="col-md-2 pt-0 pb-0 date-amount"
              >{{ moment(date.date).format("DD") }}/</span
            >
            <span class="col-md-2 pt-0 pb-0 date-amount"
              >{{ moment(date.date).format("MM") }}/</span
            >
            <span class="col-md-2 pt-0 pb-0 date-amount">{{
              moment(date.date).format("YYYY")
            }}</span>
          </h6>
        </div>
        <div
          :class="[
            'pt-0 pb-0 d-flex align-items-center',
            report_type == 'general' && 'col-md-8',
            report_type == 'analytical' && 'col-md-10',
          ]"
        >
          <h6 v-if="date.resident" class="m-0">{{ date.resident.name }}</h6>
        </div>
      </div>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockInput.totalAmountInput }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockOutput.totalAmountOutput }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockOutput.totalAmountLoss }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-2">
      <h6 class="m-0 text-amount">
        {{ date.totalInStock }} {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { professionalClassCouncilValue } from "../../../lib/format";

export default {
  name: "Medicine",
  props: {
    date: Object,
    report_type: String,
    medicine_name: String,
    active_ingredient: String,
    unit_of_measurement_abbreviation: String,
  },
  methods: {
    moment,
    professionalClassCouncilValue,
  },
};
</script>
